import { useState, useEffect, useRef } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import "../Utils/assets/css/header.css";
import "../Utils/assets/css/custom.css";
import "../Utils/assets/css/styles.css";
import "../Utils/assets/css/icons.css";
import useLocalStorageState from "use-local-storage-state";
import { UpdateRF } from "../Utils/hooks/ApiHandler";
import { useNavigate } from "react-router-dom";
import { defaultImage, imageURL } from "../Utils/constants/constant";
import { CreateDeal } from "../Pages/deals/CreateDeal";
import { Tasks } from "../Pages/Forms/Tasks";
import { CreateCompany } from "./../CommonComponents/CreateCompany";
import { CreateLead } from "./../Pages/Leads/CreateLead";
import ProfileOffCanvas from "../Profile/ProfileOffcanvas";
import { toast } from "sonner";
import { ContactForm } from "../Pages/Contacts/ContactModule/ContactForm";
import { useQueryClient } from "react-query";
import { getCountries } from "../Utils/hooks/location";
import { useOutsideClickHandler } from "../Utils/hooks/useOutsideClickHandler";
import NotificationDropdown from "./NotificationDropdown";
import { GlobalSearch } from "../layouts/header/GlobalSearch";
import {
  IconMenu2,
  IconLayoutSidebarLeftExpand,
  IconPlus,
  IconChevronDown,
  IconHelpCircle,
  IconBuilding,
  IconUserCircle,
  IconLock,
  IconSettings,
  IconCreditCard,
  IconLogout,
  IconLayers,
  IconInbox,
} from "@tabler/icons-react";

const Header = ({ collapsed, setCollapsed, onOpenMobile }) => {
  const createRef = useRef(null);
  const userRef = useRef(null);
  const [createOpen, setCreateOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const [showProfileCanvas, setShowProfileCanvas] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 992);
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [openContactOffcanvas, setOpenContactOffcanvas] = useState(false);
  const [openCompanyOffcanvas, setOpenCompanyOffcanvas] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  const [openDealOffcanvas, setOpenDealOffcanvas] = useState(false);
  const [openLeadOffcanvas, setOpenLeadOffcanvas] = useState(false);
  const [openTaskOffcanvas, setOpenTaskOffcanvas] = useState(false);
  const [openMeetings, setOpenMeetings] = useState(false);

  const [customer, setCustomer] = useLocalStorageState("customer");
  const [PERMISSION] = useLocalStorageState("permission");

  const contactCreate = PERMISSION?.contact?.isCreate;
  const dealCreate = PERMISSION?.deals?.isCreate;
  const leadCreate = PERMISSION?.leads?.isCreate;
  const companyCreate = PERMISSION?.company?.isCreate;
  const quotationCreate = PERMISSION?.quotation?.isCreate;
  const isQuotation = PERMISSION?.quotation?.isAuthorized;
  const inboxView = PERMISSION?.dashboard?.inboxView;
  const projectView = PERMISSION?.dashboard?.projectView;

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useOutsideClickHandler({
    objRef: createRef,
    isDropdown: createOpen,
    setDropdown: setCreateOpen,
  });

  useOutsideClickHandler({
    objRef: userRef,
    isDropdown: userOpen,
    setDropdown: setUserOpen,
  });

  const details = customer?.customer_details || {};
  const displayName =
    [details.first_name, details.last_name].filter(Boolean).join(" ") ||
    "User";
  const displayEmail = details.email || "";
  const role = details.role_title || "User";
  const organization =
    details.company_name ||
    details.organization ||
    details.org_name ||
    details.business_name ||
    "PugCRM";
  const profileSrc =
    !details.profile_img
      ? defaultImage
      : details.profile_img?.startsWith("http")
        ? details.profile_img
        : `${imageURL}${details.profile_img}`;

  const handleLogout = () => {
    UpdateRF(customer?.token?.authentication);
    queryClient.clear();
    setCustomer({
      customer_details: {},
      customer_status: "Inactive",
      user_login: false,
      token: {},
    });
    localStorage.clear();
    navigate("/login");
  };

  const runCreate = (fn) => {
    setCreateOpen(false);
    fn();
  };

  return (
    <>
      <header className="crm-header">
        <div className="crm-header__left">
          <button
            type="button"
            className="crm-header__icon-btn crm-header__menu-btn"
            onClick={onOpenMobile}
            aria-label="Open sidebar menu"
          >
            <IconMenu2 size={20} />
          </button>

          {collapsed && (
            <button
              type="button"
              className="crm-header__icon-btn crm-header__expand-btn"
              onClick={() => setCollapsed?.(false)}
              title="Expand sidebar"
              aria-label="Expand sidebar"
            >
              <IconLayoutSidebarLeftExpand size={20} />
            </button>
          )}

          <div className="crm-header__org" title={organization}>
            <span className="crm-header__org-icon">
              <IconBuilding size={13} stroke={2} />
            </span>
            <span className="crm-header__org-name">{organization}</span>
          </div>
        </div>

        <div className="crm-header__center">
          <GlobalSearch />
        </div>

        <div className="crm-header__right">
          {!isSmallScreen && (
            <>
              <button
                type="button"
                className="crm-header__icon-btn"
                title="Projects"
                onClick={() => {
                  if (!projectView) {
                    toast.warning("You are not authorized for this action!");
                    return;
                  }
                  navigate("/ProjectDashboard");
                }}
              >
                {/* <IconLayers size={18} stroke={1.75} /> */}
              </button>
              <button
                type="button"
                className="crm-header__icon-btn"
                title="Inbox"
                onClick={() => {
                  if (!inboxView) {
                    toast.warning("You are not authorized for this action!");
                    return;
                  }
                  navigate("/inbox");
                }}
              >
                <IconInbox size={18} stroke={1.75} />
              </button>
            </>
          )}

          <div className="position-relative" ref={createRef}>
            <button
              type="button"
              className="crm-header__create-btn"
              onClick={() => setCreateOpen((v) => !v)}
            >
              <IconPlus size={15} stroke={2.5} />
              <span className="crm-header__create-label">Create</span>
              <IconChevronDown
                size={12}
                style={{
                  transform: createOpen ? "rotate(180deg)" : "none",
                  transition: "transform 0.15s",
                }}
              />
            </button>

            {createOpen && (
              <div className="crm-popover crm-popover--create">
                <div className="crm-popover__section-label">Records</div>
                <button
                  type="button"
                  className="crm-popover__item"
                  onClick={() =>
                    runCreate(() => {
                      if (!leadCreate) {
                        toast.warning("You are not authorized for this action!");
                        return;
                      }
                      setOpenLeadOffcanvas(true);
                    })
                  }
                >
                  <i className="fa-solid fa-user" />
                  Add Lead
                </button>
                <button
                  type="button"
                  className="crm-popover__item"
                  onClick={() =>
                    runCreate(() => {
                      if (!contactCreate) {
                        toast.warning("You are not authorized for this action!");
                        return;
                      }
                      setOpenContactOffcanvas(true);
                    })
                  }
                >
                  <i className="fa-solid fa-address-book" />
                  Add Contact
                </button>
                <button
                  type="button"
                  className="crm-popover__item"
                  onClick={() =>
                    runCreate(() => {
                      if (!companyCreate) {
                        toast.warning("You are not authorized for this action!");
                        return;
                      }
                      setOpenCompanyOffcanvas(true);
                    })
                  }
                >
                  <i className="bx bxs-buildings" />
                  Add Company
                </button>
                <button
                  type="button"
                  className="crm-popover__item"
                  onClick={() =>
                    runCreate(() => {
                      if (!dealCreate) {
                        toast.warning("You are not authorized for this action!");
                        return;
                      }
                      setOpenDealOffcanvas(true);
                    })
                  }
                >
                  <i className="fa-solid fa-sack-dollar" />
                  Add Deals
                </button>
                <button
                  type="button"
                  className="crm-popover__item"
                  onClick={() =>
                    runCreate(() => {
                      if (!quotationCreate || !isQuotation) {
                        toast.warning(
                          !quotationCreate
                            ? "You are not authorized for this action!"
                            : "Upgrade your plan to create Quotation!"
                        );
                        return;
                      }
                      navigate("/createquotation");
                    })
                  }
                >
                  <i className="fa-solid fa-file-invoice" />
                  Add Quotation
                </button>
                <div className="crm-popover__divider" />
                <div className="crm-popover__section-label">Activities</div>
                <button
                  type="button"
                  className="crm-popover__item"
                  onClick={() => runCreate(() => setOpenTaskOffcanvas(true))}
                >
                  <i className="fa-solid fa-square-check" />
                  Add Task
                </button>
              </div>
            )}
          </div>

          <div className="crm-header__divider" />

          <Dropdown as="div" className="position-relative">
            <Dropdown.Toggle
              as="button"
              type="button"
              className="crm-header__icon-btn"
              style={{ border: 0, background: "transparent" }}
              title="Notifications"
            >
              <i
                className="fa-solid fa-bell"
                style={{ fontSize: "1rem", color: "#64748b" }}
              />
            </Dropdown.Toggle>
            <NotificationDropdown />
          </Dropdown>

          <button
            type="button"
            className="crm-header__icon-btn"
            title="Help & Support"
            onClick={() =>
              toast.info("PugCRM help center — contact your administrator for workspace support.")
            }
          >
            <IconHelpCircle size={18} stroke={1.75} />
          </button>

          <div className="crm-header__divider" />

          <div className="position-relative" ref={userRef}>
            <button
              type="button"
              className="crm-header__user-btn"
              onClick={() => setUserOpen((v) => !v)}
              aria-label="User account menu"
            >
              <div className="crm-header__avatar">
                <img
                  src={profileSrc}
                  alt={displayName}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = defaultImage;
                  }}
                />
                <span className="crm-header__online" />
              </div>
              <div className="crm-header__user-meta">
                <p className="crm-header__user-name">{displayName}</p>
                <p className="crm-header__user-role">{role}</p>
              </div>
              <IconChevronDown
                size={13}
                className={`crm-header__chevron${userOpen ? " crm-header__chevron--open" : ""
                  }`}
              />
            </button>

            {userOpen && (
              <div className="crm-popover crm-popover--user" style={{ zIndex: 102 }}>
                <div className="crm-popover__user-head">
                  <div className="crm-popover__user-head-row">
                    <div className="crm-popover__user-avatar">
                      <img
                        src={profileSrc}
                        alt={displayName}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = defaultImage;
                        }}
                      />
                    </div>
                    <div style={{ minWidth: 0, flex: 1 }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                          flexWrap: "wrap",
                        }}
                      >
                        <strong
                          style={{
                            fontSize: 14,
                            color: "#0f172a",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {displayName}
                        </strong>
                        <span
                          style={{
                            fontSize: 10,
                            fontWeight: 600,
                            textTransform: "uppercase",
                            background: "#f9f2f6",
                            color: "#7a3a5e",
                            borderRadius: 4,
                            padding: "1px 6px",
                          }}
                        >
                          {role}
                        </span>
                      </div>
                      <div
                        style={{
                          fontSize: 13,
                          color: "#64748b",
                          marginTop: 2,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {displayEmail}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                          fontSize: 12,
                          color: "#94a3b8",
                          marginTop: 4,
                        }}
                      >
                        <IconBuilding size={11} />
                        <span
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {organization}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ padding: 6 }}>
                  <div className="crm-popover__section-label">Account</div>
                  <button
                    type="button"
                    className="crm-popover__item"
                    onClick={() => {
                      setUserOpen(false);
                      setShowProfileCanvas(true);
                    }}
                  >
                    <IconUserCircle size={15} />
                    Personal Profile
                  </button>
                  <button
                    type="button"
                    className="crm-popover__item"
                    onClick={() => {
                      setUserOpen(false);
                      navigate("/changePassword");
                    }}
                  >
                    <IconLock size={15} />
                    Security & Password
                  </button>
                </div>

                <div className="crm-popover__divider" />

                <div style={{ padding: 6 }}>
                  <div className="crm-popover__section-label">Workspace</div>
                  <button
                    type="button"
                    className="crm-popover__item"
                    onClick={() => {
                      setUserOpen(false);
                      navigate("/setup/companyDetails");
                    }}
                  >
                    <IconSettings size={15} />
                    CRM Setup
                  </button>
                  <button
                    type="button"
                    className="crm-popover__item"
                    onClick={() => {
                      setUserOpen(false);
                      navigate("/subscriptiondetails");
                    }}
                  >
                    <IconCreditCard size={15} />
                    CRM Subscription
                  </button>
                  {isSmallScreen && (
                    <>
                      <button
                        type="button"
                        className="crm-popover__item"
                        onClick={() => {
                          setUserOpen(false);
                          if (!projectView) {
                            toast.warning("You are not authorized for this action!");
                            return;
                          }
                          navigate("/ProjectDashboard");
                        }}
                      >
                        {/* <IconLayers size={15} /> */}
                        Projects
                      </button>
                      <button
                        type="button"
                        className="crm-popover__item"
                        onClick={() => {
                          setUserOpen(false);
                          if (!inboxView) {
                            toast.warning("You are not authorized for this action!");
                            return;
                          }
                          navigate("/inbox");
                        }}
                      >
                        <IconInbox size={15} />
                        Inbox
                      </button>
                    </>
                  )}
                </div>

                <div className="crm-popover__divider" />

                <div style={{ padding: 6 }}>
                  <button
                    type="button"
                    className="crm-popover__item crm-popover__item--danger"
                    onClick={handleLogout}
                  >
                    <IconLogout size={15} />
                    Sign Out
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </header>

      <OffcanvasComponents
        openContactOffcanvas={openContactOffcanvas}
        setOpenContactOffcanvas={setOpenContactOffcanvas}
        openDealOffcanvas={openDealOffcanvas}
        setOpenDealOffcanvas={setOpenDealOffcanvas}
        openTaskOffcanvas={openTaskOffcanvas}
        setOpenTaskOffcanvas={setOpenTaskOffcanvas}
        openLeadOffcanvas={openLeadOffcanvas}
        setOpenLeadOffcanvas={setOpenLeadOffcanvas}
        openMeetings={openMeetings}
        setOpenMeetings={setOpenMeetings}
        openCompanyOffcanvas={openCompanyOffcanvas}
        setOpenCompanyOffcanvas={setOpenCompanyOffcanvas}
        setReloadKey={setReloadKey}
      />

      {showProfileCanvas && (
        <ProfileOffCanvas
          show={showProfileCanvas}
          handleClose={() => setShowProfileCanvas(false)}
        />
      )}
    </>
  );
};

const OffcanvasComponents = ({
  openContactOffcanvas,
  setOpenContactOffcanvas,
  openDealOffcanvas,
  setOpenDealOffcanvas,
  openTaskOffcanvas,
  setOpenTaskOffcanvas,
  openLeadOffcanvas,
  setOpenLeadOffcanvas,
  openMeetings,
  setOpenMeetings,
  openCompanyOffcanvas,
  setOpenCompanyOffcanvas,
  setReloadKey,
}) => {
  const [PERMISSION] = useLocalStorageState("permission");
  const [country, setCountries] = useState([{ countryName: "", countryId: 0 }]);
  const masterGrant = PERMISSION?.setting?.feature?.master;

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const data = await getCountries();
        if (data) {
          setCountries(
            data.map((c) => ({
              countryName: c.name,
              countryId: c.id,
            }))
          );
        }
      } catch {
        return;
      }
    };
    if (openContactOffcanvas) {
      fetchCountries();
    }
  }, [openContactOffcanvas]);

  return (
    <>
      <ContactForm
        show={openContactOffcanvas}
        setShow={setOpenContactOffcanvas}
        country={country}
        masterGrant={masterGrant}
      />
      <CreateDeal
        show={openDealOffcanvas}
        onHide={() => setOpenDealOffcanvas(false)}
        moduleName="deals"
      />
      <Tasks
        show={openTaskOffcanvas}
        onCanvasClose={() => setOpenTaskOffcanvas(false)}
        contactId="0"
      />
      <CreateLead
        show={openLeadOffcanvas}
        onHide={() => setOpenLeadOffcanvas(false)}
        module_name="leads"
      />
      {openCompanyOffcanvas && (
        <CreateCompany
          setReloadKey={setReloadKey}
          show={openCompanyOffcanvas}
          setShow={setOpenCompanyOffcanvas}
        />
      )}
      {openMeetings && (
        <Modal show={openMeetings} onHide={() => setOpenMeetings(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Meetings</Modal.Title>
          </Modal.Header>
          <Modal.Body />
        </Modal>
      )}
    </>
  );
};

export default Header;
